APP.testDriveCheckin = function () {
	const el = $('.test-drive-checkin');
	if (el.length === 0) return false;

	const holder = el.find('.test-drive-checkin__holder');
	const holderWidth = holder.innerWidth();
	const inner = el.find('.test-drive-checkin__inner');
	const loading = el.find('.loading');

	let isLoading = false;

	const form1 = el.find('.info-step1');
	const ticketCode = form1.find('[name="ticket_code"]');

	const form2 = el.find('.info-step2');
	const modelSelect = form2.find('[name="model"]');
	const versionSelect = form2.find('[name="version"]');
	const typeRoad = form2.find('[name="type_road"]');
	const testDriveFormat = form2.find('[name="test_drive_format"]');
	const STT = form2.find('[name="seat_number"]');

	const form3 = el.find('.info-step3');

	const form4 = el.find('.info-step4');
	const form4otp = el.find('.info-step4-otp');
	const btnResendSignature = $('.btn--resend-signature');
	const btnResendSignatureCount = btnResendSignature.find('.btn__count');
	const btnVerifySignatureLater = $('.btn-kysau');

	const maxInputFile = 4;
	const btnInputFile = $('.btn-input-file');

	const thankYou = $('.thank-you-1');

	const backButtons = el.find('.btn-back');
	let currentFormPos = 0;
	let dataCheckPhone = {};
	let userEventData = [];
	let userEventSelected = {};
	let dataSubmitLast = {
		utm_source: getCookie('utm_source') ? getCookie('utm_source') : '',
		utm_content: getCookie('utm_content') ? getCookie('utm_content') : '',
		utm_medium: getCookie('utm_medium') ? getCookie('utm_medium') : '',
		utm_campaign: getCookie('utm_campaign') ? getCookie('utm_campaign') : '',
		mmv_campaign: getCookie('mmv_campaign') ? getCookie('mmv_campaign') : '',
	};
	let dataSubmit = {
		...dataSubmitLast,
	};

	const validImageTypes1 = ['heif', 'heic'];
	const validImageTypes = ['dng'];
	let currentInputFile = 0;

	let timeLeft = 120;
	let timerId;

	let checkinData = null;

	let croppers = [];

	let isAnimating = false;

	function animForm(isBack) {
		currentFormPos = isBack ? currentFormPos + holderWidth : currentFormPos - holderWidth;
		APP.setScrollTopAnimation(0);
		isAnimating = true;
		TweenMax.to(inner, 0.4, {
			x: currentFormPos,
			ease: Power1.easeOut,
			onComplete: function () {
				isAnimating = false;
			},
		});
	}

	function animForm3(isBack) {
		currentFormPos = isBack ? currentFormPos + holderWidth : currentFormPos - holderWidth;
		APP.setScrollTopAnimation(0);
		isAnimating = true;
		TweenMax.to(inner, 0.4, {
			x: currentFormPos,
			ease: Power1.easeOut,
			onComplete: function () {
				isAnimating = false;
			},
		});
	}

	function animForm4(isBack) {
		currentFormPos = isBack ? currentFormPos + holderWidth : currentFormPos - holderWidth;
		APP.setScrollTopAnimation(0);
		isAnimating = true;
		TweenMax.to(inner, 0.4, {
			x: currentFormPos,
			ease: Power1.easeOut,
			onComplete: function () {
				isAnimating = false;
			},
		});
	}

	function init() {
		btnInputFile.on('click', renderUploadFileToDom);

		const canvas = document.querySelector('canvas');

		const signaturePad = new SignaturePad(canvas, {
			//backgroundColor: 'rgb(255, 255, 255)',
		});

		signaturePad.addEventListener('endStroke', () => {
			gsap.set('.signature__clear', {
				autoAlpha: 1,
			});
			$('[name="image_signature_file"]').val(signaturePad.toDataURL('image/png'));
			$('[name="image_signature_file"]').parents('.form__group').removeClass(CLASS._error);
			$('[name="image_signature_file"]').parents('.form__group').find('.form__error').html('');
		});

		$('.signature__clear').on('click', function (e) {
			e.preventDefault();
			signaturePad.clear();
			gsap.set('.signature__clear', {
				autoAlpha: 0,
			});
			$('[name="image_signature_file"]').val('');
		});

		$('.signature__add').on('click', function (e) {
			e.preventDefault();
			const _this = $(this);
			const signature = _this.parents('.signature');
			const parent = signature.parent();
			const btnText = _this.find('.btn__text');
			const textSignature = _this.data('text-signature');
			const textSignatureAfter = _this.data('text-signature-after');

			if (!signature.hasClass('is-show')) {
				signature.addClass('is-show');
				btnText.text(textSignatureAfter);
				$('[name="sign_later"]').val(0);
				signaturePad.clear();
				parent.attr('data-required', true);
				$('.signature__body').show();
				$('.signature__note').hide();
			} else {
				signature.removeClass('is-show');
				btnText.text(textSignature);
				$('[name="sign_later"]').val(1);
				parent.removeAttr('data-required').removeClass('is-error');
				parent.find('.form__error').html('');
				$('.signature__body').hide();
				$('.signature__note').show();
			}
			$('[name="image_signature_file"]').val('');
		});

		form3.on('change', '.file-upload-image input[type="file"]', async function (e) {
			if (e.target.files.length === 0) return;
			const _this = $(this);
			const value = _this.val();
			const parent = _this.parents('.form__group');
			const fileBrowser = parent.find('.file-browser__text');
			const fileProgress = parent.find('.file-progress');
			const imagePreview = parent.find('.image-preview');
			const fileProgressPercent = fileProgress.find('.file-progress__percent');
			const preview = parent.find('.image-preview__gplx');

			// const fileUploadHidden = $('[name="file-upload-hidden"]');
			// const fileUploadHiddenParrent = fileUploadHidden.parent();
			// const fileUploadHiddenError = fileUploadHiddenParrent.find('.form__error');

			fileBrowser.hide();

			function createPreviewImage(imageurl) {
				preview.html('');
				const previewItem = $(`<div class="image-preview-item" style="padding: 1vw 0;"></div>`);
				const image = new Image();
				image.src = imageurl;
				previewItem.append(image);
				preview.append(previewItem);
				function onLoadImage() {
					const cropper = new Cropper(image, {
						viewMode: 1,
						zoomOnTouch: false,
						zoomable: false,
						zoomOnWheel: false,
						autoCrop: true,
						// aspectRatio: 3 / 2,
						responsive: false,
						restore: false,
						ready() {
							cropper.zoomTo(1);
							const containerData = cropper.getContainerData();
							cropper.setCropBoxData({
								width: containerData.width,
								height: containerData.height,
								left: 0,
								top: 0,
							});
						},
					});
					croppers.push(cropper);
				}
				image.addEventListener('load', onLoadImage);
				fileProgress.hide();
				imagePreview.show();
				// fileUploadHidden.val(value);
				// fileUploadHiddenParrent.removeClass('is-error');
				// fileUploadHiddenError.html('');
				parent.find('.file-upload-image__hidden').hide();
			}

			if (validImageTypes.includes(e.target.files[0].name.split('.').pop())) {
				fileProgress.show();
				parent.find('.file-upload-image__hidden').show();

				let formData = new FormData();
				formData.append('file', e.target.files[0]);
				formData.append('user_id', checkinData.data_website.id);
				formData.append('id_user', checkinData.data_website.id);
				formData.append('note', dataSubmit.event_code);
				formData.append('from', 'MMV');

				isLoading = true;
				loading.show();

				$.ajax({
					url: `${api}/file/convert`,
					type: 'POST',
					data: formData,
					xhr: function () {
						var xhr = new window.XMLHttpRequest();
						xhr.upload.addEventListener(
							'progress',
							function (evt) {
								if (evt.lengthComputable) {
									const textProcess = fileProgress.find('.file-progress__text strong').eq(1);
									var percentComplete = evt.loaded / evt.total - 0.5;
									if (percentComplete < 0.5) {
										fileProgressPercent.css({
											width: `${Math.round(percentComplete * 100)}%`,
										});
									}
									if (percentComplete === 0.5) {
										// Fake converting process
										setInterval(() => {
											if (percentComplete >= 0.99) return;
											percentComplete += 0.01;
											fileProgressPercent.css({
												width: `${Math.round(percentComplete * 100)}%`,
											});
											textProcess.html(`Đang chuyển đổi...`);
										}, 500);
									}
								}
							},
							false
						);
						return xhr;
					},
					success: function (data) {
						const {
							result,
							item: { url_file_convert },
						} = data;
						if (result === 'success') {
							createPreviewImage(url_file_convert);
						}
						loading.hide();
						isLoading = false;
					},
					cache: false,
					contentType: false,
					processData: false,
				});
			} else if (validImageTypes1.includes(e.target.files[0].name.split('.').pop())) {
				const blob = e.target.files[0];
				heic2any({
					blob,
					toType: 'image/jpeg',
					quality: 0.5,
				})
					.then((conversionResult) => {
						var image = URL.createObjectURL(conversionResult);
						createPreviewImage(image);
					})
					.catch((e) => {
						console.log(e);
					});
			} else {
				const preview = parent.find(`.image-preview__gplx`);
				[...e.target.files].map((file) => {
					image = URL.createObjectURL(file);
					createPreviewImage(image);
				});
			}
		});

		form3.on('click', '.image-preview__remove', function (e) {
			e.preventDefault();
			const _this = $(this);
			const parent = _this.parents('.form__group');
			const inputFile = parent.find('input');
			const fileBrowser = parent.find('.file-browser__text');
			const imagePreview = parent.find('.image-preview');

			inputFile.val('');
			fileBrowser.show();
			imagePreview.hide();
		});

		form3.on('click', '.file-browser__remove', function (e) {
			e.preventDefault();
			const _this = $(this);
			const parent = _this.parents('.file-upload-image');
			parent.remove();
			currentInputFile--;
			$('.btn-input-file').show();
			$('.file-upload-image').map(function (i, e) {
				if (i === 0) return;
				const _this = $(this);
				const fileTitle = _this.find('.file-upload-title');
				fileTitle.html(`Hình ảnh ${i}`);
			});
		});
		if ($('[name="visibled_signature"]').val() === '0') {
			$('.signature__add').hide();
		}

		ticketCode.focus();
		// Init code from url
		// Step 1
		APP.validate(form1, {
			isAjax: true,
			onComplete: function (data) {
				dataSubmit = { ...dataSubmit, ...data };
				// console.log(dataSubmit);
				if (isLoading || isAnimating) return false;
				isLoading = true;
				loading.show();
				APP.getData(
					`${api}/crm/customer/ticket?ticket_code=${data.ticket_code}&event_code=${data.event_code}&event_id=${data.event_id}&visibled_signature=${dataSubmit.visibled_signature}`,
					function (data) {
						loading.hide();
						isLoading = false;
						if (data.result === 'fail') {
							form1.find('.form__error--response').html(data.errorMessage);
							return false;
						} else if (data.data_website.event_code !== dataSubmit.event_code) {
							form1.find('.form__error--response').html('Mã vé không đúng');
							return false;
						} else {
							checkinData = data;
							dataSubmit.event_code = data.data_crm.data.eventCode;
							// dataSubmit.event_id = data.data_crm.data.eventId;
							dataSubmit.crm_customer_id = data.data_crm.data.id;
							form1.find('.form__error--response').html('');
							// Update info on step 2
							form2
								.find('.test-drive-checkin__customer')
								.html(' ' + data.data_crm.data.customerName + '<br/>');
							form2
								.find('.test-drive-checkin__phone')
								.html(' ' + data.data_crm.data.customerPhone + '<br/>');
							form2
								.find('.test-drive-checkin__email')
								.html(' ' + data.data_crm.data.customerEmail + '<br/>');
							form2
								.find('.test-drive-checkin__agency')
								.html(' ' + data.data_crm.data.dealerName + '<br/>');
							form2.find('.test-drive-checkin__by').html(' ' + data.data_crm.data.checkInByName);
							form2.find('.test-drive-checkin__at').html(' ' + data.data_crm.data.checkInAt);

							// Model mapping

							// Type road
							// if (!data.data_crm.eventData.longroad) {
							// 	typeRoad.find('option[value="longRoad"]').remove();
							// }
							// if (!data.data_crm.eventData.topographic) {
							// 	typeRoad.find('option[value="topographic"]').remove();
							// }

							let haveLongRoad = false;
							let haveTopographic = false;
							data.data_crm.eventData.listConfigTestDrive.forEach((item) => {
								if (item.typeDriveModel === 'longRoad') {
									haveLongRoad = true;
								}
								if (item.typeDriveModel === 'topographic') {
									haveTopographic = true;
								}
							});

							if (!haveLongRoad) {
								typeRoad.find('option[value="longRoad"]').remove();
							}
							if (!haveTopographic) {
								typeRoad.find('option[value="topographic"]').remove();
							}

							typeRoad.on('change', function () {
								modelSelect.parent().removeClass('d-none');
								const existingModels = [];
								const models = data.data_crm.eventData.listConfigTestDrive.map((item) => {
									if (
										existingModels.indexOf(item.modelCarId) === -1 &&
										item.typeDriveModel === typeRoad.val()
									) {
										existingModels.push(item.modelCarId);
										return `<option value="${item.modelCarId}">${item.modelCar}</option>`;
									}
								});
								modelSelect.html('<option value="">Chọn mẫu xe</option>');
								modelSelect.append(models);
								modelSelect.val('').trigger('change');
							});

							modelSelect.on('change', function () {
								if ($(this).val() === '') {
									versionSelect.html('').val('').trigger('change').parent().addClass('d-none');
									testDriveFormat.parent().addClass('d-none');
								} else {
									// const modelId = parseInt($(this).val(), 10);
									const modelId = $(this).val();
									const existVersion = [];
									const versions = data.data_crm.eventData.listConfigTestDrive
										.filter((item) => item.modelCarId === modelId)
										.map((item) => {
											if (
												existVersion.indexOf(item.versionModelId) === -1 &&
												item.typeDriveModel === typeRoad.val()
											) {
												existVersion.push(item.versionModelId);
												return `<option value="${item.versionModelId}">${item.versionModelName}</option>`;
											}
										});
									versionSelect.html('<option value="">Chọn phiên bản</option>');
									versionSelect.append(versions).parent().removeClass('d-none');
									testDriveFormat.parent().removeClass('d-none');
								}
							});

							// versionSelect.on('change', function () {
							// const typeRoads = data.data_crm.eventData.listConfigTestDrive
							// 	.filter((item) => {
							// 		return (
							// 			item.modelCarId === parseInt(modelSelect.val(), 10) &&
							// 			item.versionModelId === parseInt(versionSelect.val(), 10)
							// 		);
							// 	})
							// 	.map((item) => {
							// 		const typeDriveName =
							// 			item.typeDriveModel === 'topographic' ? 'Sa hình' : 'Đường trường';
							// 		return `<option value="${item.typeDriveModel}">${typeDriveName}</option>`;
							// 	});
							// typeRoad.html('<option value="">Chọn loại hình</option>');
							// typeRoad.append(typeRoads).parent().removeClass('d-none');
							// typeRoad.parent().removeClass('d-none');
							// });

							// Driving licence
							// drivingLicence.val(data.data_crm.data.drivingLicense).trigger('change');

							// Form 2 mapping
							if (!data.data_crm.eventData.isTestDriveFormat) {
								testDriveFormat.find('option[value="testDriveType"]').remove();
							}
							if (!data.data_crm.eventData.isSitWithMMV) {
								testDriveFormat.find('option[value="sitWithMMV"]').remove();
							}
							if (!data.data_crm.eventData.isSitWithOrder) {
								testDriveFormat.find('option[value="sitWithOrder"]').remove();
							}

							// get stt from server
							testDriveFormat.on('change', function () {
								if (testDriveFormat.find('option:selected').val() === 'sitWithOrder') {
									loading.show();
									APP.getData(
										`${api}/crm/customer/getOrderIdSitWith?customer_id&ticket_code=${
											dataSubmit.ticket_code
										}&model=${modelSelect.val()}&type_road=${typeRoad.val()}&event_id=${
											dataSubmit.event_id
										}&event_code=${data.data_crm.eventData.code}`,
										function (data) {
											loading.hide();
											const stts = data.items.map((item) => {
												return `<option value="${item.id}">${item.name}</option>`;
											});
											STT.append(stts);
											STT.parent()
												.removeClass('d-none')
												.removeClass(CLASS._error)
												.attr('data-required', true);
											STT.parent();
										}
									);
								} else {
									STT.parent()
										.addClass('d-none')
										.removeClass(CLASS._error)
										.removeAttr('data-required');
								}
							});

							animForm();
						}
					}
				);
				return false;
			},
		});

		const code = getParameterByName('ticket_code');
		if (code) {
			ticketCode.val(code);
			form1.find('[type="submit"]').trigger('click');
		}

		APP.validate(form2, {
			isAjax: true,
			onComplete: function (data) {
				dataSubmit = { ...dataSubmit, ...data };
				console.log(dataSubmit);
				animForm();
				return false;
			},
		});

		APP.validate(form3, {
			isAjax: true,
			onComplete: function (data) {
				if (isLoading || isAnimating) return;
				isLoading = true;
				loading.show();

				dataSubmit = {
					...dataSubmit,
					driving_licence: data.driving_licence,
				};

				const files = croppers.map((item) => {
					return item.getCroppedCanvas().toDataURL('image/jpeg');
				});

				const dataUpload = {
					note: dataSubmit.event_code,
					files,
					id_user: checkinData.data_website.id,
				};

				fetch(`${api}/file/upload`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						lang: _lang,
					},
					body: JSON.stringify(dataUpload),
				})
					.then((res) => res.json())
					.then((data) => {
						isLoading = false;
						loading.hide();
						if (data.result === 'success') {
							form1.find('.form__error--response').html('');
							const fileIds = data.files.map((item) => item.id).join(',');
							dataSubmit = {
								...dataSubmit,
								file_id: fileIds,
							};
							animForm3();
						} else {
							form3.find('.form__error--response').html(data.errorMessage);
						}
					});
			},
		});

		APP.validate(form4, {
			isAjax: true,
			onComplete: function (resForm4) {
				const { sign_later, image_signature_file } = resForm4;

				if (sign_later === '0') {
					const dataUpload = {
						note: dataSubmit.event_code + '-signature',
						files: [image_signature_file],
						id_user: checkinData.data_website.id,
					};

					loading.show();

					fetch(`${api}/file/upload`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							lang: _lang,
						},
						body: JSON.stringify(dataUpload),
					})
						.then((res) => res.json())
						.then((data) => {
							loading.hide();

							if (data.result === 'success') {
								grecaptcha.ready(function () {
									grecaptcha
										.execute('6LcCEBgnAAAAAJ_0NFiVTQSlpDYZ35ypza8kH-Qv', { action: 'submit' })
										.then(function (token) {
											form4.find('.form__error--response').html('');
											const fileIds = data.files.map((item) => item.id).join(',');
											dataSubmit = {
												...dataSubmit,
												...resForm4,
												image_signature: fileIds,
												g_token: token,
											};

											const formData = new URLSearchParams();
											for (let key in dataSubmit) {
												formData.append(key, dataSubmit[key]);
											}

											submitData(form4, formData);
										});
								});
							} else {
								form4.find('.form__error--response').html(data.errorMessage);
							}
						});
				} else {
					dataSubmit = {
						...dataSubmit,
						...resForm4,
						signature_verify_later: 0,
					};

					const formData = new URLSearchParams();
					for (let key in dataSubmit) {
						formData.append(key, dataSubmit[key]);
					}
					if (!dataSubmit.file_id) {
						formData.append('file_id', '');
					}

					submitData(form4, formData);
				}
			},
		});

		APP.validate(form4otp, {
			isAjax: true,
			onComplete: function (data) {
				dataCheckPhone = {
					...dataCheckPhone,
					otp_code: data.otp_code_signature,
					phone: checkinData.data_crm.data.customerInfo.phone,
					id: checkinData.data_website.id,
				};
				if (isLoading || isAnimating) return;
				isLoading = true;
				loading.show();

				fetch(`${api}/crm/customer/ticket/signature/otp/verify`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Cookie: 'PHPSESSID=bn1pik82vpnsp9lqdkbjo44amk',
						lang: _lang,
					},
					body: JSON.stringify(dataCheckPhone),
				})
					.then((res) => res.json())
					.then((data) => {
						isLoading = false;
						loading.hide();

						if (data?.result === 'fail') {
							form4otp.find('.form__error--response').html(data.errorMessage);
						} else {
							TweenMax.to(el, 0.4, {
								autoAlpha: 0,
								ease: Power1.easeOut,
								onComplete: function () {
									el.hide();
								},
							});

							if (data?.item?.orderIdTestDriveName) {
								thankYou.find('.title').html(' ' + data.item.customer_name);
								thankYou.find('.thank-you__sttname').html(' ' + data.item.orderIdTestDriveName);
								TweenMax.to(thankYou, 0.4, {
									autoAlpha: 1,
									display: 'block',
									ease: Power1.easeOut,
								});
							} else {
								thankYou2.find('.title').html(' ' + data.item.customer_name);

								TweenMax.to(thankYou2, 0.4, {
									autoAlpha: 1,
									display: 'block',
									ease: Power1.easeOut,
								});
							}
						}
					});
			},
		});

		// Back buttons
		backButtons.on('click', function (e) {
			if (isAnimating) return;
			animForm(true);
			e.preventDefault();
		});

		thankYou.find('.btn-close').on('click', function (e) {
			TweenMax.to(thankYou, 0.4, {
				autoAlpha: 0,
				display: 'none',
				ease: Power1.easeOut,
				onComplete: function () {},
			});
			// remove param ticket_code
			const url = new URL(window.location.href);
			url.searchParams.delete('ticket_code');
			window.location.href = url.href;
		});

		btnResendSignature.on('click', function (evt) {
			evt.preventDefault();
			// resend api otp
			loading.show();
			dataCheckPhone.delete('otp_code');
			fetch(`${api}/crm/customer/ticket/signature/otp/resend`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Cookie: 'PHPSESSID=bn1pik82vpnsp9lqdkbjo44amk',
					lang: _lang,
				},
				body: JSON.stringify(dataCheckPhone),
			})
				.then((res) => res.json())
				.then((data) => {
					isLoading = false;
					loading.hide();

					if (data?.result === 'fail') {
						form4otp.find('.form__error--response').html(data.errorMessage);
					} else {
						btnResendSignature.addClass(CLASS._disabled);
						timerId = setInterval(countdown, 1000);
						if (data.otp_code !== '') {
							$('[name="otp_code_signature"]').val(data?.data?.signature_otp_code);
							$('[name="otp_code_signature"]').parent().addClass(CLASS._focus);
							setTimeout(() => {
								$('[name="otp_code_signature"]').focus();
							}, 500);
						}
					}
				});
		});

		btnVerifySignatureLater.on('click', function (evt) {
			const formData = new URLSearchParams();
			dataSubmit = {
				...dataSubmit,
				sign_later: 1,
				signature_verify_later: 1,
			};

			for (let key in dataSubmit) {
				formData.append(key, dataSubmit[key]);
			}
			submitData(form4, formData);
		});
	}

	function submitData(form, formData) {
		if (isLoading || isAnimating) return;
		isLoading = true;
		loading.show();
		formData.delete('image_signature_file');

		fetch(`${api}/crm/customer/ticket/${checkinData.data_website.id}`, {
			method: 'PUT',
			body: formData,
		})
			.then((res) => res.json())
			.then((data) => {
				isLoading = false;
				loading.hide();
				if (data.result === 'success') {
					if (dataSubmit.sign_later === '0' && data?.data?.signature_otp_code !== 'undefined') {
						$('[name="otp_code_signature"]').val(data?.data?.signature_otp_code);
						animForm4();
						setTimeout(() => {
							$('[name="otp_code_signature"]').focus();
						}, 500);
						$('.phone-signature').html(`${checkinData.data_crm.data.customerPhone}`);
						timerId = setInterval(countdown, 1000);
					} else {
						TweenMax.to(el, 0.4, {
							autoAlpha: 0,
							ease: Power1.easeOut,
							onComplete: function () {
								el.hide();
							},
						});

						if (data?.item?.orderIdTestDriveName) {
							thankYou.find('.title').html(' ' + data.item.customer_name);
							thankYou.find('.thank-you__sttname').html(' ' + data.item.orderIdTestDriveName);
							TweenMax.to(thankYou, 0.4, {
								autoAlpha: 1,
								display: 'block',
								ease: Power1.easeOut,
							});
						} else {
							thankYou2.find('.title').html(' ' + data.item.name);

							TweenMax.to(thankYou2, 0.4, {
								autoAlpha: 1,
								display: 'block',
								ease: Power1.easeOut,
							});
						}
					}
				} else {
					form.find('.form__error--response').html(data.errorMessage);
				}
			});
	}

	const fileUploadImage = $('.file-upload-image').eq(0).clone();
	function renderUploadFile(idx) {
		const fileUploadImageClone = fileUploadImage.clone();

		fileUploadImageClone
			.find('[name="file_GPLX"]')
			.attr('data-add-file', idx)
			.attr('name', `file_GPLX_${idx}`)
			.attr('id', `file_GPLX_${idx}`);

		fileUploadImageClone.find('label').attr('for', `file_GPLX_${idx}`);

		fileUploadImageClone
			.find('.file-browser')
			.prepend(`<button type="button" class="file-browser__remove">Remove</button>`);

		$('.file-upload-image').eq(idx).after(fileUploadImageClone);

		$('.file-upload-image').map(function (i, e) {
			if (i === 0) return;
			const _this = $(this);
			const fileTitle = _this.find('.file-upload-title');
			fileTitle.html(`Hình ảnh ${i}`);
		});

		return fileUploadImageClone;
	}

	function renderUploadFileToDom(e) {
		e.preventDefault();
		if (currentInputFile >= maxInputFile - 1) {
			$('.btn-input-file').hide();
		}

		if (currentInputFile < maxInputFile) {
			renderUploadFile(currentInputFile);
			// $('.file-upload__render').append(uploadItem);
			currentInputFile++;
		}
	}

	function countdown() {
		if (timeLeft < 0) {
			clearTimeout(timerId);
			timeLeft = 120;
			btnResendSignature.removeClass(CLASS._disabled);
			btnResendSignatureCount.html('(120s)');
		} else {
			btnResendSignatureCount.html(`(${timeLeft}s)`);
			timeLeft--;
		}
	}

	init();
};
